import React from 'react';
import MailerBuilder from '../../mailSetup/MailerBuilder';
import BenefitMailerWorkspace from '../../mailSetup/BenefitMailerWorkspace';
import { Breadcrumb } from '../../common/atoms';

export default function BenefitAdoptionMailerDashboard() {
  return <section className="mx-auto min-w-0 max-w-[1340px]">
    <Breadcrumb list={[{ text: 'Engagement', link: '/stepathon' }, { text: 'Benefit mailers', link: '#' }]} classes="mb-ds-4" />
    <MailerBuilder types={['benefit_mailer', 'marketing']} backPath="/benefit-adoption-mailers" renderBenefitWorkspace={props => <BenefitMailerWorkspace {...props} />} />
  </section>;
}
